
import Startpage from './components/pages/Startpage'
import LoginCallback from './components/pages/LoginCallback'
import Error403 from './components/pages/Error403'
import EpLandshutPlan from './components/pages/EpLandshutPlan'
import EpLandshutUpload from './components/pages/EpLandshutUpload'
import RedirectPage from './components/pages/RedirectPage'

/*Routes are based on org units*/

export default [
    {
        path: "/", component: Startpage, name: "Startpage", meta: {
            //comment in line below if the start page already needs authentication
            requiresAuth: true
        }
    },
    {
        path: "/callback", component: LoginCallback, name: "Login Success"
    },
    {
        path: "/403", component: Error403, name: "No Permission"
    },


    //#################################################################################################################

    /**
     * Redirect Route. The route will detact the right shiftplan and forward
     */
    {
        path: "/redirect", component: RedirectPage, name: "Load correct plan", meta: {
            requiresAuth: true
        }
    },
    //#################################################################################################################
    //############ TEST TEAMS ###################
    //10023251 - Service Management Germany
    //10200860 - IT-RC
    //Spielwiese
    {
        path: "/ep", component: EpLandshutPlan, name: "EP Landshut Plan", meta: {
            requiresAuth: true
        }
    },
    //IT-REUDE
    {
        path: "/10023251", component: EpLandshutPlan, name: "Regional Deutschland Plan", meta: {
            requiresAuth: true,
            scopes: ["OU_10200860", "OU_10023251"]
        }
    },
    /*
    #########################################################################################
    LANDSHUT EP - User Shift Plans
    #########################################################################################
        ## Löt und Filterkappen ##
        10020014 - EP-LD41
        10000756 - EP-4

        ## Sensoren / Automotive / Opto Sockel ##
        10000754 - EP-LD2
        10019994 - EP-LD21

        ## Opto Kappen ##
        10000764 - EP-LD31
        10000755 - EP-LD3

        ## Großdurchführnugen
        10169300 - EP-LD11
        10023388 - EP-LD1

        ## Gestellgalvanik ##
        10007681 - EP-LO11
        10109175 - EP-LO1

        ## Trommelgalvanik ##
        10109176 - EP-LO12
        10109175 - EP-LO1

        ## Glasabschnitte ##
        10000729 - EP-LG2
        10000724 - EP-LG

        ## Fertigung Hybrid ##
        10000760 - EP-LD51
        10111136 - EP-LD5

        ## Fertigung LED ##
        10179231 - EP-LD52
        10111136 - EP-LD5

        ## Fertigung Presslinge ##
        10000728 - EP-LG3

        ## Fertigung Glaspulver ##
        10076762 - EP-LG4

    ################################################################################################
    */


    /*
        ## Großdurchführnugen
        10169300 - EP-LD11
        10023388 - EP-LD1
        */
    {
        path: "/10169300", component: EpLandshutPlan, name: "EPLD11 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10169300", //EPLD11
                "OU_10023388" //EPLD1
            ]
        }
    },
    /*
    ## Sensoren / Automotive / Opto Sockel ##
    10000754 - EP-LD2
    10019994 - EP-LD21
    */
    {
        path: "/10019994", component: EpLandshutPlan, name: "EPLD21 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10019994", //EPLD21
                "OU_10000754" //EPLD2
            ]
        }
    },
    /*
    ## Opto Kappen ##
    10000764 - EP-LD31
    10000755 - EP-LD3
    */
    {
        path: "/10000764", component: EpLandshutPlan, name: "EPLD31 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10000764", //EPLD31
                "OU_10000755" //EPLD3
            ]
        }
    },
    /*
    ## Löt und Filterkappen ##
    10020014 - EP-LD41
    10000756 - EP-4
    */
    {
        path: "/10020014", component: EpLandshutPlan, name: "EPLD41 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10020014", //EPLD41
                "OU_10000756" //EPLD4
            ]
        }
    },

    /*
    ## Glasabschnitte ##
    10000729 - EP-LG2
    10000724 - EP-LG
    */
    {
        path: "/10000729", component: EpLandshutPlan, name: "EPLG2 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10000729", //EP-LG2
                "OU_10000724" //EP-LG
            ]
        }
    },
    /*
     ## Gestellgalvanik ##
        10007681 - EP-LO11
        10109175 - EP-LO1    
    */
    {
        path: "/10007681", component: EpLandshutPlan, name: "EPLO11 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10007681", //EPLO11
                "OU_10000754" //EPLD2
            ]
        }
    },
    /*
    ## Trommelgalvanik ##
        10109176 - EP-LO12
        10109175 - EP-LO1
    */
    {
        path: "/10109176", component: EpLandshutPlan, name: "EPLO12 Landshut Plan", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10109176", //EPLO12
                "OU_10109175" //EPLO1
            ]
        }
    },
    /*
    ## Fertigung Hybrid ##
        10000760 - EP-LD51
        10111136 - EP-LD5
    */
   {
       path: "/10000760", component: EpLandshutPlan, name: "EPL51 Landshut Plan", meta: {
        requiresAuth: true,
        scopes: [
            "OU_10200860", //IT-RC
            "OU_10000760", //EPLD51
            "OU_10111136" //EPLD5
        ]
        }
    },
    /*
    ## Fertigung LED ##
        10179231 - EP-LD52
        10111136 - EP-LD5
        00009654 - Employee ID for Ludwig Mittermeier - He is leading LD51 and LD52
    */
   {
       path: "/10179231", component: EpLandshutPlan, name: "EPLD52 Landshut Plan", meta: {
           requiresAuth: true,
           scopes: [
               "OU_10200860", //IT-RC
               "OU_10179231", //EPLD52
               "OU_10111136", //EPLD5
               "EID_00009654"
            ]
        }
    },
    /*
    ## Fertigung Presslinge ##
        10000728 - EP-LG3
    */
   {
    path: "/10000728", component: EpLandshutPlan, name: "EPLG3 Landshut Plan", meta: {
        requiresAuth: true,
        scopes: [
            "OU_10200860", //IT-RC
            "OU_10000728"
         ]
     }
 },
     /*
    ## Fertigung Glaspulver ##
        10076762 - EP-LG4
    */
   {
    path: "/10076762", component: EpLandshutPlan, name: "EPLG4 Landshut Plan", meta: {
        requiresAuth: true,
        scopes: [
            "OU_10200860", //IT-RC
            "OU_10076762"
         ]
     }
 },
    //IT-RC
    {
        path: "/10200860", component: EpLandshutPlan, name: "IT-RC Plan", meta: {
            requiresAuth: true,
            scopes: ["OU_10200860"]
        }
    },

    //#################################################################################################################
    /**
     * UPLOAD PAGES
     ##################################################################################################################
     */

      /*
        ## Großdurchführnugen
        10169300 - EP-LD11
        10023388 - EP-LD1
        */
    {
        path: "/10169300upload", component: EpLandshutUpload, name: "EPLD11 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10169300", //EPLD11
                "OU_10023388" //EPLD1
            ]
        }
    },
    /*
    ## Sensoren / Automotive / Opto Sockel ##
    10000754 - EP-LD2
    10019994 - EP-LD21
    */
    {
        path: "/10019994upload", component: EpLandshutUpload, name: "EPLD21 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10019994", //EPLD21
                "OU_10000754" //EPLD2
            ]
        }
    },
    /*
    ## Opto Kappen ##
    10000764 - EP-LD31
    10000755 - EP-LD3
    */
    {
        path: "/10000764upload", component: EpLandshutUpload, name: "EPLD31 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10000764", //EPLD31
                "OU_10000755" //EPLD3
            ]
        }
    },
    /*
    ## Löt und Filterkappen ##
    10020014 - EP-LD41
    10000756 - EP-4
    */
    {
        path: "/10020014upload", component: EpLandshutUpload, name: "EPLD41 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10020014", //EPLD41
                "OU_10000756" //EPLD4
            ]
        }
    },

    /*
    ## Glasabschnitte ##
    10000729 - EP-LG2
    10000724 - EP-LG
    */
    {
        path: "/10000729upload", component: EpLandshutUpload, name: "EPLG2 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10000729", //EP-LG2
                "OU_10000724" //EP-LG
            ]
        }
    },
    /*
     ## Gestellgalvanik ##
        10007681 - EP-LO11
        10109175 - EP-LO1    
    */
    {
        path: "/10007681upload", component: EpLandshutUpload, name: "EPLO11 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10007681", //EPLO11
                "OU_10000754" //EPLD2
            ]
        }
    },
    /*
    ## Trommelgalvanik ##
        10109176 - EP-LO12
        10109175 - EP-LO1
    */
    {
        path: "/10109176upload", component: EpLandshutUpload, name: "EPLO12 Upload", meta: {
            requiresAuth: true,
            scopes: [
                "OU_10200860", //IT-RC
                "OU_10109176", //EPLO12
                "OU_10109175" //EPLO1
            ]
        }
    },
        /*
    ## Fertigung Hybrid ##
        10000760 - EP-LD51
        10111136 - EP-LD5
    */
   {
    path: "/10000760upload", component: EpLandshutUpload, name: "EPLD51 Upload", meta: {
     requiresAuth: true,
     scopes: [
         "OU_10200860", //IT-RC
         "OU_10000760", //EPLD51
         "OU_10111136" //EPLD5
     ]
     }
 },
 /*
 ## Fertigung LED ##
     10179231 - EP-LD52
     10111136 - EP-LD5
     00009654 - Employee ID for Ludwig Mittermeier - He is leading LD51 and LD52
 */
{
    path: "/10179231upload", component: EpLandshutUpload, name: "EPLD52 Upload", meta: {
        requiresAuth: true,
        scopes: [
            "OU_10200860", //IT-RC
            "OU_10179231", //EPLD52
            "OU_10111136", //EPLD5
            "EID_00009654"
         ]
     }
 },
 /*
 ## Fertigung Presslinge ##
     10000728 - EP-LG3
 */
{
 path: "/10000728upload", component: EpLandshutUpload, name: "EPLG3 Upload", meta: {
     requiresAuth: true,
     scopes: [
         "OU_10200860", //IT-RC
         "OU_10000728"
      ]
  }
},
  /*
 ## Fertigung Glaspulver ##
     10076762 - EP-LG4
 */
{
 path: "/10076762upload", component: EpLandshutUpload, name: "EPLG4 Upload", meta: {
     requiresAuth: true,
     scopes: [
         "OU_10200860", //IT-RC
         "OU_10076762"
      ]
  }
},

    //Spielwiese
    {
        path: "/epupload", component: EpLandshutUpload, name: "EP Landshut Upload", meta: {
            requiresAuth: true
        }
    },
    //Spielwiese
    {
        path: "/10023251upload", component: EpLandshutUpload, name: "Regional IT Deutschland Upload", meta: {
            requiresAuth: true
        }
    },
    //IT-RC
    {
        path: "/10200860upload", component: EpLandshutUpload, name: "Upload IT-RC Plan", meta: {
            requiresAuth: true
        }
    },
];